import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Modal } from 'react-bootstrap';
import GallerySlider from './GallerySlider';
import api from '../../api';
import ContainerLoader from '../loader/container-loader';
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

function Gallery() {
    const [show, setShow] = useState(false);
    const [initialSlide, setInitialSlide] = useState(0);
    const [galleryImages, setGalleryImages] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const sliderRef = useRef(null);
    const authState = useSelector((state) => state.authUser);
    const user_id = authState?.profile?.user_id;
    const user_email = authState?.profile?.email;

    const fetchGalleryImages = async () => {
        try {
            setIsFetching(true);
            const request = { resource: 'api/sharepoint/gethrdgallery' };
            const response = await api.sharepoint.fetchGalleryImages(request);
            setGalleryImages(response?.data?.data || []);
        } catch (error) {
            console.log(error.message);
        } finally {
            setIsFetching(false);
        }
    }

    useEffect(() => {
        fetchGalleryImages();
    }, [])

    const handleClose = () => {
        setInitialSlide(0);
        setShow(false);
        setTimeout(() => {
            if (sliderRef.current) {
                sliderRef.current.slickPlay();
            }
        }, 1000);
    };

    const handleOpen = (index) => {
        setInitialSlide(index);
        setShow(true);
        trackEvent('hrd_moments_captured_viewed', 'HRD Moments Captured Viewed', 'HRD Moments Captured Viewed', 1, user_id, user_email);
        if (sliderRef.current) {
            sliderRef.current.slickPause();
        }
    };

    const settings = {
        dots: false,
        infinite: galleryImages.length > 4,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        rows: 2,
        slidesPerRow: 2,
    };
    
    return (
        <>{isFetching ? <ContainerLoader /> : 
        <>
            <Modal
                className='momentsModal'
                show={show}
                size='xl'
                centered
                onHide={() => handleClose()}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Body>
                    <GallerySlider handleClose={handleClose} images={galleryImages} initialSlide={initialSlide} />
                </Modal.Body>
            </Modal>
            <div className="slider-container moments-captured" >
                <Slider {...settings} ref={sliderRef}>
                    {galleryImages.map((item, index) => <div key={index}>
                        <img src={item} alt={item} style={{ margin: 'auto', cursor: 'pointer', width: '100%' }} className='hrdcapturesImage' onClick={() => { handleOpen(index) }} />
                    </div>)}
                </Slider>
            </div>
        </>}
        </>
    );
}

export default Gallery
